import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="font-heading text-xl font-bold whitespace-nowrap hover:text-primary-300 transition-colors">
              白洁传研究中心
            </Link>
            <p className="mt-4 text-background-400 text-sm leading-relaxed">
              致力于白洁传的研究、整理与传播，为读者提供全面深入的文学解读与文化分析。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-200 mb-4">分类导航</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/category/character-analysis" className="text-background-400 hover:text-background-100 text-sm transition-colors whitespace-nowrap">人物分析</Link>
              <Link to="/category/version-intro" className="text-background-400 hover:text-background-100 text-sm transition-colors whitespace-nowrap">版本介绍</Link>
              <Link to="/category/story-background" className="text-background-400 hover:text-background-100 text-sm transition-colors whitespace-nowrap">故事背景</Link>
              <Link to="/category/cultural-interpretation" className="text-background-400 hover:text-background-100 text-sm transition-colors whitespace-nowrap">文化解读</Link>
              <Link to="/category/original-appreciation" className="text-background-400 hover:text-background-100 text-sm transition-colors whitespace-nowrap">原著赏析</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-200 mb-4">关于我们</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/about" className="text-background-400 hover:text-background-100 text-sm transition-colors whitespace-nowrap">品牌介绍</Link>
              <Link to="/about#reputation" className="text-background-400 hover:text-background-100 text-sm transition-colors whitespace-nowrap">学术声誉</Link>
              <Link to="/about#contact" className="text-background-400 hover:text-background-100 text-sm transition-colors whitespace-nowrap">联系我们</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-200 mb-4">关注我们</h4>
            <div className="flex items-center gap-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 transition-colors" aria-label="微信公众号">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 transition-colors" aria-label="知乎">
                <i className="ri-zhihu-line text-lg"></i>
              </a>
            </div>
            <p className="mt-4 text-background-500 text-xs">
              联系邮箱：contact@baijiezhuan.com
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-500 text-xs">
            &copy; {new Date().getFullYear()} 白洁传研究中心 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-background-300 text-xs transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-background-500 hover:text-background-300 text-xs transition-colors whitespace-nowrap">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}